module.exports = __webpack_public_path__ + "static/media/bell_black.bace9787.svg";